import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4076184907 from "../../../../../packages/component/src/components/menu-button/demo/demo1.js?loadDemo";
import legacyImportDemo_3027698216 from "../../../../../packages/component/src/components/menu-button/demo/demo2.js?loadDemo";
import legacyImportDemo_2001330697 from "../../../../../packages/component/src/components/menu-button/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4076184907,
  legacyImportDemo_3027698216,
  legacyImportDemo_2001330697,
  React
};